import SectionHeading from "@/pages/home/components/SectionHeading";
import { values } from "@/mocks/content";

export default function ValuesSection() {
  return (
    <section id="about" className="scroll-mt-20 border-t border-background-200/70 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="order-2 lg:order-1">
            <div className="h-[280px] w-full overflow-hidden rounded-2xl border border-background-200 md:h-[360px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20living%20room%20corner%20with%20handwritten%20letters%2C%20dried%20flowers%20in%20a%20ceramic%20vase%20and%20a%20soft%20knitted%20blanket%20on%20a%20linen%20sofa%2C%20stylized%20painterly%20editorial%20photography%2C%20cream%20coral%20and%20sage%20palette%2C%20soft%20afternoon%20window%20light%2C%20blurred%20intimate%20background%2C%20tender%20nostalgic%20mood%2C%20delicate%20grain%20texture%2C%20harmonious%20composition&width=1200&height=800&seq=loveisland-value-01&orientation=landscape"
                alt="温暖客厅一角摆放着信件、干花与毛毯"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <SectionHeading
              eyebrow="关于爱情岛"
              title="我们想做的，是陪你把关系过好"
              desc="爱情岛不教你套路，也不承诺捷径。我们相信，一段好的关系离不开理解与练习，于是把那些真正有用的内容整理在这里。"
            />

            <div className="mt-7 space-y-4">
              {values.map((value) => (
                <div key={value.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${value.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{value.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{value.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}